import { Box, Typography } from "@mui/material";
import { SxProps } from "@mui/system";

const style: SxProps = {
  mb: 2,
};

export default function Help() {
  return (
    <>
      <Typography variant="h5" sx={{ ...style }}>
        Технически изисквания
      </Typography>
      <Box sx={{ ...style }}>
        <Typography sx={{ ...style }}>
          Порталът за електронни административни услуги на Нотариална камара на Република България е разработен и
          тестван за работа със следните видове браузъри:
        </Typography>

        <Box sx={{ ...style }}>
          <Typography>- Google Chrome 49 или по-нов;</Typography>
          <Typography>- Edge 14 или по-нов;</Typography>
          <Typography>- Mozilla Firefox 52 или по-нов;</Typography>
          <Typography>- Safari 10 или по-нов;</Typography>
        </Box>

        <Typography>За вход в системата се използва квалифициран електронен подпис, съдържащ ЕГН.</Typography>
      </Box>

      <Typography variant="h5" sx={{ ...style }}>
        Електронен подпис
      </Typography>
      <Typography sx={{ ...style }}>
        За идентифициране на потребителите Информационната система използва квалифициран електронен подпис, съдържащ
        информация за Единния граждански номер (ЕГН) на физическото лице.
      </Typography>
      <Typography sx={{ ...style }}>
        Електронният подпис трябва да е издаден от регистриран за България от Комисията за регулиране на съобщенията
        доставчик на удостоверителни услуги.
      </Typography>
      <Typography sx={{ ...style }}>
        Предвижда се в бъдеще системата да работи с квалифицирани електронни подписи, издадени от доставчици на
        удостоверителни услуги, установени в други държави членки на Европейския съюз и Европейското икономическо
        пространство.
      </Typography>
      <Typography sx={{ ...style }}>
        При опит за идентифициране на потребител с друг вид електронен подпис системата извежда съобщение за грешка.
      </Typography>

      <Typography variant="h5" sx={{ ...style }}>
        Въпроси и отговори
      </Typography>
      <Typography variant="h5">Въпроси, свързани с електронния подпис</Typography>
      <ul>
        <li>
          <Typography>Как да се сдобия с квалифициран електронен подпис?</Typography>
          <Typography sx={{ ...style }}>
            Комисия за регулиране на съобщенията поддържа Регистър на доставчиците на удостоверителни услуги, издаващи
            удостоверения за квалифициран електронен подпис. Необходимо е да си закупите от някой от доставчиците
            квалифициран електронен подпис, съдържащ ЕГН.
          </Typography>
        </li>

        <li>
          <Typography>Как да си инсталирам електронен подпис?</Typography>
          <Typography sx={{ ...style }}>
            Ако притежавате квалифициран електронен подпис, издаден от регистриран от КРС доставчик на удостоверителни
            услуги, е необходимо да се обърнете към доставчика или да проверите в неговата интернет страница в разделите
            „Инструкции за инсталация“ и „Инструкции за ползване“.
          </Typography>
        </li>
      </ul>

      <Typography variant="h5">Термини</Typography>
      <ul>
        <li>
          <Typography>Квалифициран електронен подпис</Typography>
          <Typography sx={{ ...style }}>
            Законовото определение за квалифициран електронен подпис е дадено в чл. 16 от Закона за електронния документ
            и електронния подпис. Той се издава само от доставчик на удостоверителни услуги заедно с удостоверение за
            квалифициран електронен подпис. Всеки издаден квалифициран електронен подпис се свързва по уникален начин с
            неговия автор, гаранция е за авторството на изявленията, направени от притежателя на подписа и е създаден по
            начин, който да ограничи в максимална степен възможността за неправомерни външни посегателства.
          </Typography>
          <Typography sx={{ ...style }}>
            Или образно казано, електронният подпис е устройство, наподобяващо на външен вид USB памет, кредитна карта с
            чип или SIM карта за телефон, на която е записан електронният сертификат (удостоверение за квалифициран
            електронен подпис).
          </Typography>
        </li>
        <li>
          <Typography>Квалифициран електронен подпис, съдържащ ЕГН</Typography>
          <Typography sx={{ ...style }}>
            Системата работи само с квалифицирани електронни подписи, съдържащи ЕГН на физическо лице. Тъй като
            доставчиците не са задължени да включват ЕГН в подписа, е необходимо изрично да заявите желанието си за
            това.
          </Typography>
        </li>
      </ul>
    </>
  );
}
